import React, { useEffect } from 'react';
import Icon from './icons';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMenuCollapseSelector } from '../store/selectors/loaderSelector';
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: any;
    className?: string;
    title?:string;
    back?:string;
}

const Header: React.FC<Props> & {
    Left: React.FC<Props>
    Right: React.FC<Props>
} = ({ children, className, title, back }) => {

    const dispatch = useDispatch();

    const left = children?.find?.((child:any) => child.type === Header.Left) || null;
    const right = children?.find?.((child:any) => child.type === Header.Right) || children;
    const collapse = useMenuCollapseSelector();

    const handleSidebarToggle = () => {
        // Implement sidebar toggle logic here
        dispatch({ type: 'ACTIONS/LOADER/MENU_COLLAPSE', payload: !collapse });
    };

    return (
        <header className='bg-white h-[3.75rem] relative flex-shrink-0 border-b border-gray-200 font-black'>
            <div className='flex items-center justify-between h-full px-3 font-semibold'>
                <div className='flex h-full justify-center items-center gap-4'>
                    <div className='pe-5 ps-3 h-full flex border-e border-gray-200 items-center cursor-pointer' onClick={handleSidebarToggle}>
                        <Icon name='sidebar' size={1.35} className='text-gray-700' />
                    </div>

                    {back? <Link to={back}><Icon name='arrow-left' size={1.35} className='text-gray-700' /></Link> : null}
                    {title? <h1 className='text-xl truncate max-w-[200px] sm:max-w-[300px] md:max-w-[400px] lg:max-w-[900px]' title={title}>{title}</h1> : null}
                    {left}
                </div>
                <div className='flex items-center gap-2'>
                    {right}
                    
                </div>
            
            </div>
           
        </header>
    );
};

Header.Left = ({children, className}) => {
    return (<>{children}</>);
}

Header.Right = ({children, className}) => {
    return (<>{children}</>);
}

Header.Left.displayName = 'Header.Left';
Header.Right.displayName = 'Header.Right';

export default Header;